"use strict";function openAuth$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openAuth$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.alipay.openAuth";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.8"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.8"},_a)),exports.openAuth$=openAuth$,exports.default=openAuth$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/alipay/openAuth.js
// module id = 906
// module chunks = 106